export function msisdnToIntl(msisdn) {
    return msisdn ? msisdn.replace('0', '+44') : '';
}

export function formatMsisdn(msisdn) {
    return msisdn ? msisdn.replace(/^(\d{5})(\d{6})$/, '$1-$2') : '';
}